module.exports = __webpack_public_path__ + "europa-50_signature.jpg?5a87b4c9c8f94fecbc3ae197bd71d296";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50_signature.jpg
// module id = 380
// module chunks = 0